<template>
    <div class="menu-left-mobile" :class="{active: menuActive}">
        <div class="close-menu" @click="close()">
            <span>x</span>
        </div>
        <ul class="menu">
            <li class="title-menu">
                <div class="content">
                    <span>MENÚ</span>
                </div>
            </li>
            <router-link class="item" tag="li" to="/" exact>
                <div class="content">
                    <span>Inicio. Video</span>
                </div>
            </router-link>
            <router-link class="item" tag="li" to="usar-el-cinturon">
                <div class="content">
                    <span>Usar el cinturón</span>
                </div>
            </router-link>
            <router-link class="item" tag="li" to="respetar-las-reglas">
                <div class="content">
                    <span>Respetar las reglas</span>
                </div>
            </router-link>
            <router-link class="item" tag="li" to="reducir-la-velocidad">
                <div class="content">
                    <span>Reducir la velocidad</span>
                </div>
            </router-link>
            <router-link class="item" tag="li" to="proteger-a-los-ninos">
                <div class="content">
                    <span>Proteger a los niños</span>
                </div>
            </router-link>
            <router-link class="item" tag="li" to="prestar-atencion">
                <div class="content">
                    <span>Prestar atención</span>
                </div>
            </router-link>
            <router-link class="item" tag="li" to="manejar-descansado">
                <div class="content">
                    <span>Manejar descansado</span>
                </div>
            </router-link>
            <router-link class="item" tag="li" to="usar-casco">
                <div class="content">
                    <span>Usar casco</span>
                </div>
            </router-link>
            <router-link class="item" tag="li" to="ser-cortes">
                <div class="content">
                    <span>Ser cortés</span>
                </div>
            </router-link>
            <router-link class="item" tag="li" to="revisar-el-auto">
                <div class="content">
                    <span>Revisar el auto</span>
                </div>
            </router-link>
            <router-link class="item" tag="li" to="consejos-adicionales">
                <div class="content">
                    <span>Consejos</span>
                </div>
            </router-link>
            <router-link class="item" tag="li" to="certificado-gxsv">
                <div class="content">
                    <span>Certificado gxsv</span>
                </div>
            </router-link>
        </ul>
        <ul class="downloads">
            <li>
                <div class="content">
                    <span class="download-title">RUTAS <small>DESCARGABLES</small> GXSV</span>
                </div>
            </li>
            <li class="item" @click="goTo('pdfs/01.ruta1-comic.pdf')">
                <div class="content">Ruta 1</div>
            </li>
            <li class="item" @click="goTo('pdfs/02.ruta2-comic.pdf')">
                <div class="content">Ruta 2</div>
            </li>
            <li class="item" @click="goTo('pdfs/03.ruta3-comic.pdf')">
                <div class="content">Ruta 3</div>
            </li>
            <li>
                <div class="content">¡DESCARGALAS YA!</div>
            </li>
        </ul>
        <ul class="salir" v-if="showCloseSession">
            <li class="item close" @click="signOut">
                <div class="content">
                    <span>SALIR</span>
                </div>
            </li>
        </ul>
    </div>
</template>

<script>
    export default {
        props: {
            active: {
                type: Boolean,
                default: false
            }
        },
        name: "SideBarLeftMobile",
        mounted() {
            this.showCloseSession = !!this.$store.state.api_token
            console.log(localStorage.getItem('api_token'))
            this.$store.subscribe((mutation, state) => {
                this.showCloseSession = !!state.api_token
            })
        },
        data() {
            return {
                menuActive: false,
                showCloseSession: false
            }
        },
        watch: {
            active(value) {
                this.menuActive = value;
            }
        },
        methods: {
            close() {
                this.$emit('close')
            },
            goTo(url) {
                window.open(url, '_blank')
            },
            signOut() {
                this.$emit('sign-out')
            }
        }
    }
</script>

<style lang="sass" scoped>
    .menu-left-mobile
        background-color: white
        height: 100%
        position: fixed
        top: 0
        left: -100%
        box-sizing: border-box
        z-index: 9999
        max-width: 100%
        overflow-x: hidden
        overflow-y: auto
        max-height: 100%
        //width: auto
        transition: all .6s ease-in-out
        &.active
            left: 0
            //min-width: 350px
        @media screen and (min-width: 48em)
            display: none
        .close-menu
            position: absolute
            top: 6px
            left: 15px
            cursor: pointer
            font-size: 2em
            font-weight: lighter
        .menu, .downloads, .salir
            list-style: none
            padding-left: 0
            margin: 0
            li
                &:not(.title-menu)
                    font-size: .6em
                    @media screen and (min-width: 360px)
                        font-size: .8em
                    @media screen and (min-width: 420px)
                        font-size: 1em
                    @media screen and (min-width: 48em)
                        font-size: 1.1em
                padding: 5px 25px 5px 45px
                box-sizing: border-box
                color: #979797
                width: 100%
                &.item
                    cursor: pointer
                .content
                    width: 100%
                    font-weight: lighter
                    max-width: 100%
                    white-space: nowrap
                    text-overflow: ellipsis
                    overflow: hidden
        .menu
            margin-top: 0
            li
                &.active
                    background: #f07c7f
                    color: white
                    .content
                        font-weight: bold
                &.title-menu
                    padding-top: 15px
                    padding-bottom: 15px
                    color: black
                    fonst-size: 1.1em
                    .content
                        text-transform: capitalize
                        font-weight: normal
                        span
                            border-bottom: 1px solid black
                .content
                    .icon
                        display: none
        .downloads
            border-top: 2px solid #d7d7d7
            margin-top: 5px
            li
                &:first-child
                    margin-bottom: 10px
                    .content
                        font-weight: normal
                        .download-title
                            border-bottom: 1px solid black
                            color: black
                .content
                    font-weight: lighter
                &:last-child
                    margin-top: 10px
                    .content
                        text-align: center
                        font-weight: normal
                        color: black
        .salir
            border-top: 2px solid #d7d7d7
            margin-top:  5px
            li
                .content
                    color: black
                    font-weight: normal
</style>